import { Card } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import BrandGroupsListPage from "@saleor/brands/components/BrandGroupsListPage";
import DeleteFilterTabDialog from "@saleor/components/DeleteFilterTabDialog";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import SaveFilterTabDialog, {
  SaveFilterTabDialogFormData
} from "@saleor/components/SaveFilterTabDialog";
import useNavigator from "@saleor/hooks/useNavigator";
import { sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import createFilterHandlers from "@saleor/utils/handlers/filterHandlers";
import React from "react";
import { useIntl } from "react-intl";

import {
  BrandGroupsUrlDialog,
  brandsListUrl,
  BrandsUrlQueryParams
} from "../../url";
import {
  areFiltersApplied,
  deleteFilterTab,
  getActiveFilters,
  getFilterOpts,
  getFilterQueryParam,
  getFilterTabs,
  saveFilterTab
} from "./filters";

export interface BrandsListPageProps {
  params: BrandsUrlQueryParams;
}

export const BrandsListPage: React.FC<BrandsListPageProps> = ({ params }) => {
  const intl = useIntl();
  const navigate = useNavigator();
  const [openModal, closeModal] = createDialogActionHandlers<
    BrandGroupsUrlDialog,
    BrandsUrlQueryParams
  >(navigate, brandsListUrl, params);

  const tabs = getFilterTabs();

  const currentTab =
    params.activeTab === undefined
      ? areFiltersApplied(params)
        ? tabs.length + 1
        : 0
      : parseInt(params.activeTab, 0);

  const [
    changeFilters,
    resetFilters,
    handleSearchChange
  ] = createFilterHandlers({
    createUrl: brandsListUrl,
    getFilterQueryParam,
    navigate,
    params
  });

  const handleTabChange = (tab: number) => {
    navigate(
      brandsListUrl({
        activeTab: tab.toString(),
        ...getFilterTabs()[tab - 1].data
      })
    );
  };

  const handleTabDelete = () => {
    deleteFilterTab(currentTab);
    navigate(brandsListUrl());
  };

  const handleTabSave = (data: SaveFilterTabDialogFormData) => {
    saveFilterTab(data.name, getActiveFilters(params));
    handleTabChange(tabs.length + 1);
  };

  const breadcrumbDirectory = [
    {
      name: "Brands"
    }
  ];
  return (
    <>
      <Container style={{ maxWidth: "inherit" }}>
        <PageBreadcrumbNavigation items={breadcrumbDirectory} />
        <PageHeader title={intl.formatMessage(sectionNames.brands)} />
        <Card>
          <BrandGroupsListPage
            params={params}
            currentTab={currentTab}
            tabs={tabs.map(tab => tab.name)}
            onTabChange={handleTabChange}
            onTabDelete={() => openModal("delete-search")}
            onTabSave={() => openModal("save-search")}
            filterOpts={getFilterOpts(params)}
            currencySymbol={undefined}
            onFilterChange={filter => changeFilters(filter)}
            initialSearch={params.query || ""}
            onSearchChange={handleSearchChange}
            onAll={resetFilters}
          />
        </Card>
      </Container>
      <SaveFilterTabDialog
        open={params.action === "save-search"}
        confirmButtonState="default"
        onClose={closeModal}
        onSubmit={handleTabSave}
      />
      <DeleteFilterTabDialog
        open={params.action === "delete-search"}
        confirmButtonState="default"
        onClose={closeModal}
        onSubmit={handleTabDelete}
        tabName={maybe(() => tabs[currentTab - 1].name, "...")}
      />
    </>
  );
};

export default BrandsListPage;
